export const isTrueish = (value: unknown): boolean => {
  if (value === true) return true;
  if (value === 1) return true;
  if (typeof value === "string") {
    const s = value.trim().toLowerCase();
    return s === "true" || s === "1" || s === "yes";
  }
  return false;
};

export const getIsResend = (raw: any): boolean => {
  if (!raw) return false;
  return (
    isTrueish(raw.is_resend) ||
    isTrueish(raw.isResend) ||
    isTrueish(raw.is_resend_letter) ||
    isTrueish(raw.isResendLetter) ||
    isTrueish(raw?.data?.is_resend) ||
    isTrueish(raw?.data?.isResend) ||
    isTrueish(raw?.data?.is_resend_letter) ||
    isTrueish(raw?.data?.isResendLetter)
  );
};

